export default {"src":"/_next/static/media/TGT.88278bdf.svg","height":18,"width":18};